@if (loading) {
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
}
@if (noTracesFound) {
  <div class="header-info">
    <span><strong>No logs found! Logs may take few minutes to be updated. Please retry later</strong> </span>
  </div>
}

@if (error) {
  <div class="error-message">
    <p>{{ error.message  }}</p>
    <p>{{ error.details  }}</p>
  </div>
}
<!-- Display Header Information -->
@if (header) {
  <div class="header-info">
    <h1> {{pageTitle}}</h1>
    <p>
      <!--<span><strong>Event ID:</strong> {{header.EventId}}</span>-->
      <span><strong>Master Code:</strong> {{header.MasterCode}}</span>
      <span><strong>Event Name:</strong> {{header.EventFriendlyName}}</span>
      <span><strong>Remark:</strong> {{header.EventRemark}}</span>
    </p>
  </div>
}

<mat-vertical-stepper [linear]="false" #stepper>
  <ng-template matStepperIcon="edit" let-index="index">
    <mat-icon aria-hidden="false" fontIcon="bolt"></mat-icon>
  </ng-template>

  <ng-template matStepperIcon="number" let-index="index">
    <mat-icon aria-hidden="false" fontIcon="bolt"></mat-icon>
  </ng-template>

  @for (trace of traces; track trace; let i = $index) {
    <mat-step>
      <ng-template matStepLabel>
        <span [ngStyle]="{'color': getSeverityColor(trace.SeverityLevel), 'font-size': '20px'}">
          <b>{{trace.Systems.Target.Type}} - {{trace.Systems.Target.FriendlyName}} - {{ trace.TimeStamp | date:'medium' }}</b>
        </span>
      </ng-template>
      <div class="step-content" [ngClass]="{ 'expanded': trace.isExpanded }">
        <div class="header">
          <span [ngStyle]="{'font-size': '18px'}"><b>{{ trace.FriendlyMessage ||  trace.Message}}</b></span>
          <button (click)="trace.isExpanded = !trace.isExpanded" class="toggle-button" mat-icon-button>
            <mat-icon>{{ trace.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        </div>
        @if (trace.isExpanded) {
          @if (sendingTicket) {
            <div class="spinner-container">
              <div class="spinner"></div>
            </div>
          }
          <h3>Severity Level</h3>
        <p [ngClass]="{
            'severity-info': trace.SeverityLevel === '1',
            'severity-warning': trace.SeverityLevel === '2',
            'severity-critical': trace.SeverityLevel === '3'
          }">
            <b>{{ getSeverityLabel(trace.SeverityLevel) }}</b>
          </p>
          <h3>System Source</h3>
          <p>{{ trace.Systems.Source.Name }} / {{ trace.Systems.Source.FriendlyName }}</p>
          <h3>System Target</h3>
          <p>{{ trace.Systems.Target.Name }} / {{ trace.Systems.Target.FriendlyName }}</p>
          <h3>Technical Message</h3>
          <p>{{ trace.Message }}</p>
          @if (trace.Error.Data) {
            <h3>Data</h3>
            <pre><code>{{ trace.Error.Data }}</code></pre>
          }
          @if (trace.Data) {
            <h3>Data</h3>
            <pre><code>{{ trace.Data }}</code></pre>
          }
          @if (trace.Error.StackTrace) {
            <h3>Error Stack Trace</h3>
            <pre><code>{{ trace.Error.StackTrace }}</code></pre>
          }
          @if (trace.Logs) {
            <h3>Logs</h3>
            <ul>
              <pre><code>@for (log of trace.Logs.split('|'); track log) {
                <li>{{ log }}</li>
              }</code></pre>
            </ul>
          }
          @if (trace.SeverityLevel === '3') {
            <button class="report-button" title="Report a bug" aria-label="Report a bug" (click)="openConfirmationDialog(trace)">
              <mat-icon aria-hidden="false" fontIcon="flag" ></mat-icon>
            </button>
          }
        }
      </div>
    </mat-step>
  }
</mat-vertical-stepper>










